import React from "react";
import {ProjectTimelineLayout} from "../../ProposalView/ProjectTimelineLayout";
import {DTC_PORTAL_TIMELINE_ID} from "../HCPTitleNav/navigation_ids";
import {PortalSection} from "../../../_shared/components/PortalSection";
import {IHCPViewProps} from "../interfaces";
import useActiveDesign from "../../../../_shared/hooks/useDesign/useActiveDesign";
import useActiveProject from "../../../../_shared/hooks/useProject/useActiveProject";
import {ProjectPriceMode} from "@natomas-org/core";
import {B2BTimelineSlide} from "../../ProposalBudgetView/components/Presentation/B2BTimelineSlide/B2BTimelineSlide";

export const HCPTimeline = (props: IHCPViewProps) => {
  const {width} = props;
  const {projectPriceMode, isDevelopmentByVilla} = useActiveProject();
  const {configuration} = useActiveDesign();
  if (projectPriceMode === ProjectPriceMode.CostPlus) {
    return (
      <PortalSection
        headerTitle={"Project Schedule"}
        width={width}
        sectionId={DTC_PORTAL_TIMELINE_ID}
      >
        <B2BTimelineSlide
          displayOptions={{
            displayQuarters: isDevelopmentByVilla,
            showTooltip: true,
            showSectionTitles: true,
            showLabelsOnBars: false,
            showLegend: true,
          }}
        />
      </PortalSection>
    );
  }
  if (!configuration?.product) {
    return null;
  }

  return (
    <PortalSection
      headerTitle={"Project Schedule"}
      width={width}
      sectionId={DTC_PORTAL_TIMELINE_ID}
    >
      <ProjectTimelineLayout />
    </PortalSection>
  );
};
